import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import type { BlocksContent } from '@strapi/blocks-react-renderer';
import type { ThreeColumnLayoutResolved } from './types';
import { SlotRenderer } from '@/components/SlotRenderer';
import { RichText } from '@/lib/render/RichText';
import {
  getSectionColorClass,
  type SectionBackgroundColor,
} from '@/lib/section-colors';

function columnBgClass(value?: string): string | undefined {
  if (!value || value === 'none') {
    return undefined;
  }
  return getSectionColorClass(value as SectionBackgroundColor);
}

export function ThreeColumnLayoutComponent({
  resolved,
}: {
  resolved: ThreeColumnLayoutResolved;
}) {
  const {
    leftBackground,
    middleBackground,
    rightBackground,
    leftColumn = [],
    middleColumn = [],
    rightColumn = [],
    leftFooter,
    middleFooter,
    rightFooter,
  } = resolved;
  const leftBg = columnBgClass(leftBackground);
  const middleBg = columnBgClass(middleBackground);
  const rightBg = columnBgClass(rightBackground);
  const leftFooterNodes = leftFooter as BlocksContent | undefined;
  const middleFooterNodes = middleFooter as BlocksContent | undefined;
  const rightFooterNodes = rightFooter as BlocksContent | undefined;

  return (
    <div className="mx-auto max-w-6xl px-4 lg:px-9">
      <div className="grid items-stretch gap-6 lg:grid-cols-3">
        <div
          className={classNames(
            'h-full min-w-0',
            leftBg && `${leftBg} rounded-2xl p-6`,
          )}
        >
          <SlotRenderer blocks={leftColumn} zoneName="leftColumn" />
        </div>
        <div
          className={classNames(
            'h-full min-w-0',
            middleBg && `${middleBg} rounded-2xl p-6`,
          )}
        >
          <SlotRenderer blocks={middleColumn} zoneName="middleColumn" />
        </div>
        <div
          className={classNames(
            'h-full min-w-0',
            rightBg && `${rightBg} rounded-2xl p-6`,
          )}
        >
          <SlotRenderer blocks={rightColumn} zoneName="rightColumn" />
        </div>
      </div>
      {(leftFooterNodes?.length ||
        middleFooterNodes?.length ||
        rightFooterNodes?.length) && (
        <div className="mt-3 grid gap-6 lg:grid-cols-3">
          <div className="text-foreground/60 min-w-0 text-xs [&_a]:underline">
            {leftFooterNodes && leftFooterNodes.length > 0 && (
              <RichText nodes={leftFooterNodes} />
            )}
          </div>
          <div className="text-foreground/60 min-w-0 text-xs [&_a]:underline">
            {middleFooterNodes && middleFooterNodes.length > 0 && (
              <RichText nodes={middleFooterNodes} />
            )}
          </div>
          <div className="text-foreground/60 min-w-0 text-xs [&_a]:underline">
            {rightFooterNodes && rightFooterNodes.length > 0 && (
              <RichText nodes={rightFooterNodes} />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
